import * as types from '../actions/action-types';

export const initialState = {
  amazonpayScriptLoadStatus: 'PRE_SCRIPT_LOAD',
};

export default function amazonpayReducer(state = initialState, action) {
  switch (action.type) {
    case types.AMAZONPAY_SCRIPT_LOAD_STATUS:
      return {
        ...state,
        amazonpayScriptLoadStatus: action.amazonpayScriptLoadStatus,
      };
    default:
      return state;
  }
}
